import { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    marginLeft: 'auto',
  },
});

export interface ListItemActionProps {
  children: ReactNode;
  className?: string;
}

export const ListItemAction = ({
  children,
  className,
}: ListItemActionProps) => {
  const classes = useStyles();

  return <div className={classNames(classes.root, className)}>{children}</div>;
};

ListItemAction.displayName = 'ListItem.Action';
